import React from 'react';

import MwdDialog from '@/components/UI/Dialog/Dialog';

import styles from '@/components/UI/Dialog/Dialog.module.css';

export type ConfirmationDialogProps = Omit<React.ComponentProps<typeof MwdDialog>, 'children'> & {
  onCancel?: () => void;
  onConfirm: () => void;
  onSecondary?: () => void;
  confirmButtonType?: 'destructive' | 'primary';
  cancelButtonType?: 'outline' | 'destructive-outline' | 'link';
  secondaryText?: string;
  cancelText?: string;
  confirmText: string;
  disabled?: boolean;
  children?: React.ReactNode;
  message?: string;
};

export const ConfirmationDialog = ({
  onCancel,
  onConfirm,
  onSecondary,
  confirmButtonType,
  cancelButtonType = 'outline',
  secondaryText,
  cancelText,
  confirmText,
  disabled,
  message,
  children,
  ...mwdProps
}: ConfirmationDialogProps) => {
  return (
    <MwdDialog className={styles.confirmationDialogStyle} {...mwdProps}>
      {message && (
        <p style={{ color: 'var(--tractie-color-content-default)', whiteSpace: 'pre-line', margin: 0 }}>{message}</p>
      )}
      {children}
      <MwdDialog.Footer
        submitCaption={confirmText}
        confirmButtonType={confirmButtonType}
        secondarySubmitCaption={secondaryText}
        handleSubmitType={(type) => (type === 'secondarySubmit' ? onSecondary?.() : onConfirm())}
        cancelCaption={cancelText}
        cancelCallback={onCancel}
        cancelButtonVariant={cancelButtonType}
        justifyContentStyle={cancelText ? 'space-between' : 'flex-end'}
        disabled={disabled}
      />
    </MwdDialog>
  );
};
